import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import {JwtService} from "../services/jwt.service";
import {HttpClient} from "@angular/common/http";
import {ApiService} from "../services";
import {UserService} from "../services";
import {map, tap} from 'rxjs/operators';
import {HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
      private jwtService: JwtService,
      private apiService: ApiService,
      private userService: UserService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig = {
      //'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Methods': '*',
      //'Content-Length': '<calculated when request is sent>',
      //'Host': '<calculated when request is sent>',
      'Content-Type': 'application/json',
      'Accept': '*/*'
    };

    const token = this.jwtService.getToken();
    //const token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX3R5cGUiOiJBRE1JTiIsInVzZXJfaWQiOiJkOTBkMTAyNTFjNDNlNjU1Y2E5OGYyZTMxODdiMTBkZiIsInVzZXJfbmFtZSI6IjA3NzEyMzQ1NjciLCJzY29wZSI6WyJDTUEiXSwiZXhwIjoxNjExMjk4MzA5LCJhdXRob3JpdGllcyI6WyJkZWwtdXNyLXJvbGUiLCJ1cGQtY3VzdCIsImRlbC1tZXIiLCJ2LXVzci1yb2xlIiwiZGVsLWN1c3QiLCJ2LWN1c3QiLCJjci1tZXIiLCJjci11c3Itcm9sZSIsInYtbWVyIiwidXBkLXVzci1yb2xlIiwidXBkLW1lciIsImxzLXVzci1yb2xlIiwiZ2VuLW1lci1xciIsInN0LWFsbC1xcnR6LXNjaCIsImxzLWN1c3QiXSwianRpIjoiYTVmMzg0ZTctNTdjMi00ZThmLWFhM2UtNjQ5N2U5ZDA2MDQyIiwiY2xpZW50X2lkIjoiQk5QTF9DTUFfQ0xJRU5UIn0.KQF0QXppza8Vzvo5N-0Xs5gapN3LVxs3e-oDU9-p33qZ1XnUKiCJFjiOWx-p1HE697wXM_VXDoTAH7k_IY7fJuvov6TRtbHp7ImyF3Waen8_-mYCGKM_2jDOhPAdAo2vYBkgcoHau73MxOhTF47KGtAZ_sXx24DRf-4Zr6ewcogOJTi9gOP9dZuLqBoBeLOwNe6P5Pi6_1EzwHYuQNg9q-rlZRyTD8t3YnS1MOAbrTId0Guuz4QsPUHlmO4_fIbdCXlonMbdrr4euOmiju-7kzYieB3JfWAyhsTSlcQ1anVfI3ttz5q3BT46lIEWWzKwHbiBqOvzU3ejmIpOzj_2hg";

    if (token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    } else {

    }
    /*if (token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }*/
    const headersConfig2 = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Authorization': 'Basic Qk5QTF9BUF9DTElFTlQ6JDJhJDEwJDVJWjlmNHg2eFMzVW5SaXguNTdZOC5kTmllbzRvUDR3MFpacjVTOTRaVXAuVGI3MFF3S3RT'
    };

    const request = req.clone({ setHeaders: headersConfig });
    const request2 = req.clone({ setHeaders: headersConfig2 });
    return next.handle(request);

    /*return next.handle(request).pipe(tap(
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            console.log(err);
            console.log('req url :: ' + req.url);
            if (err.status === 401) {
              console.log('error 401');
              let refreshToken = window.localStorage['refreshToken'];

            }
          }
        }
    ));*/

  }
}